import { useTranslation } from 'react-i18next';
import { Card, EmptyState } from '@/components/ui';
import type { LimitBillingAuditEntry } from './api';
import styles from './LimitBilling.module.css';
import { CLINIC_TZ } from '@/lib/clinic-time';

export function LimitBillingAudit({
  entries,
}: {
  entries: LimitBillingAuditEntry[];
}) {
  const { t } = useTranslation();
  return (
    <Card title={t('limitBilling.auditTitle')}>
      {entries.length === 0 ? (
        <EmptyState
          title={t('limitBilling.noAudit')}
          body={t('limitBilling.noAuditBody')}
        />
      ) : (
        <ol className={styles.auditList}>
          {entries.map((entry) => (
            <li key={entry.id}>
              <strong>{t(`limitBilling.auditActions.${entry.action}`)}</strong>
              <span>
                {entry.actor.fullName} ·{' '}
                {new Date(entry.occurredAt).toLocaleString('en-MY', {
                  timeZone: CLINIC_TZ,
                })}
              </span>
              {entry.reference && <span>{entry.reference}</span>}
              {entry.reason && <span>{entry.reason}</span>}
            </li>
          ))}
        </ol>
      )}
    </Card>
  );
}
